import React, { useState } from 'react'
import instanciaAxios from '../../miscelaneo/instanciaAxios'
import { useContextoSesion } from '../../miscelaneo/ContextoSesion'; // Importa el hook del contexto
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logo from '../../assets/imagenes/logo.png';


const Login = () => {

const navigate = useNavigate();
const { iniciarSesion } = useContextoSesion();
const [usuario, setUsuario] = useState('');
const [clave, setClave] = useState('');
const [enviando, setEnviando] = useState(false);
const [mensajeError, setMensajeError] = useState('');

const ValidarUsuario = async (e) =>{
    e.preventDefault();
    setMensajeError('');
    if (!usuario.trim()) {
      const mensaje = 'Ingrese un usuario';
      setMensajeError(mensaje);
      toast.error(mensaje);
      return;
    }

    if (!clave) {
      const mensaje = 'Ingrese la clave';
      setMensajeError(mensaje);
      toast.error(mensaje);
      return;
    }
  
    try {
      setEnviando(true);
      const respuesta = (await instanciaAxios.post('/usuario/login',{usuario,clave}))
      if (respuesta.status === 200){
        setMensajeError('');
        iniciarSesion(respuesta.data.token, respuesta.data.permisos || []);
        navigate(`/Dashboard`)
      }
    } catch (error) {
      console.log(error);

      if (error.response) {

        if (error.response.status === 401) {
          const mensaje = 'Credenciales inválidas. Verifique usuario y contraseña.';
          setMensajeError(mensaje);
          toast.error(mensaje);
        } else {
          const mensaje = error.response?.data?.mensaje || 'No se pudo iniciar sesión. Intente nuevamente.';
          setMensajeError(mensaje);
          toast.error(mensaje);
        }
      }else {
        const mensaje = 'Error del servidor. Intente nuevamente en unos minutos.';
        setMensajeError(mensaje);
        toast.error(mensaje);
      }
    } finally {
      setEnviando(false);
    }

  }


  return (
    <div className='bg-color-primario h-screen'>
      
      <div className="flex justify-center items-center h-full">
        <div className="bg-white bg-opacity-90 lg:w-1/2 mg:w-3/5 rounded-lg p-20 shadow-lg">
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Lado izquierdo - Formulario */}
            <div className="flex flex-col justify-center">
              <form onSubmit={ValidarUsuario} className="flex flex-col gap-4">
                <h1 className="font-cascadia text-2xl mb-0">¡Bienvenido/a!</h1>
                <p className='text-gray-500 text-sm'>Ingrese sus credenciales para iniciar sesión</p>

                <input
                  type="text"
                  className="w-full p-2 rounded-xl text-gray-700"
                  value={usuario}
                  onChange={(e) => {
                    setUsuario(e.target.value);
                    if (mensajeError) setMensajeError('');
                  }}
                  placeholder="Ingrese su usuario"
                />
                <input
                  type="password"
                  className="w-full p-2 rounded-xl text-gray-700"
                  value={clave}
                  onChange={(e) => {
                    setClave(e.target.value);
                    if (mensajeError) setMensajeError('');
                  }}
                  placeholder="Ingrese su contraseña"
                />
                {mensajeError && (
                  <div className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                    {mensajeError}
                  </div>
                )}
                <button
                  type="submit"
                  disabled={enviando}
                  className={`w-full text-white p-2 rounded-xl transition-colors ${
                    enviando
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-color-secundario hover:bg-color-primario'
                  }`}
                >
                  {enviando ? 'Validando...' : 'Enviar'}
                </button>
              </form>
            </div>

            {/* Lado derecho - Logo */}
            <div className="hidden lg:flex items-center justify-center overflow-hidden">
              <img 
                src={logo} 
                alt="OMNISOFT Logo" 
                className="w-[250%] h-auto object-cover scale-[2]"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default Login